export function displayDateTime(date: Date): string {
  return date.toLocaleDateString("sv") + " - " + date.toLocaleTimeString("sv");
}

export function displayTimeWithoutDateIfToday(date: Date): string {
  let returnDateTime = "";
  if (date.toLocaleDateString() !== new Date().toLocaleDateString())
    returnDateTime = date.toLocaleDateString("sv") + " - ";
  returnDateTime += date.toLocaleTimeString("sv");
  return returnDateTime;
}
